import { Autoplay, Navigation, Pagination, Keyboard } from "swiper";
import { SwiperSetup } from '@resources/swiper-setup/SwiperSetup'
import { reinitVideos, initIfAtLeast, stopIframes } from "@resources/swiper-setup/SwipertSetup.utils";

SwiperSetup.register('highlights', ({ swiperId, swiperTag, swiperEl }) => {
	return {
		modules: [Autoplay, Navigation, Keyboard, Pagination],
		direction: 'horizontal',
		loop: false,
		speed: 650,
		slidesPerView: 1,
		autoHeight: false,
		spaceBetween: 36,
		autoplay: {
			delay: 5000,
			disableOnInteraction: true,
		},
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
		navigation: {
			nextEl: '.swiper-button-next',
		},
		keyboard: {
			enabled: true,
			onlyInViewport: true,
		},
		init: initIfAtLeast(swiperEl),
		on: {
			slideChange: () => {
				reinitVideos(swiperEl);
				stopIframes(swiperEl);
			}
		}
	}
})
